const DEVICE_ID_KEY = 'goalfi_device_id';
const SESSION_IDS_KEY = 'goalfi_session_ids';

/**
 * Generates or retrieves a unique device ID for the current device
 * @returns {string} The device ID
 */
export const getOrCreateDeviceId = () => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};

/**
 * Gets the current device ID
 * @returns {string|null} The device ID or null if not found
 */
export const getDeviceId = () => {
  return localStorage.getItem(DEVICE_ID_KEY);
};

/**
 * Stores session IDs in localStorage
 * @param {string[]} sessionIds - Array of session IDs
 */
export const storeSessionIds = (sessionIds) => {
  localStorage.setItem(SESSION_IDS_KEY, JSON.stringify(sessionIds));
};

/**
 * Gets session IDs from localStorage
 * @returns {string[]} Array of session IDs
 */
export const getSessionIds = () => {
  const sessionIds = localStorage.getItem(SESSION_IDS_KEY);
  return sessionIds ? JSON.parse(sessionIds) : [];
};

/**
 * Adds a session ID to localStorage
 * @param {string} sessionId - The session ID to add
 */
export const addSessionId = (sessionId) => {
  const sessionIds = getSessionIds();
  if (!sessionIds.includes(sessionId)) {
    sessionIds.push(sessionId);
    storeSessionIds(sessionIds);
  }
};

/**
 * Removes a session ID from localStorage
 * @param {string} sessionId - The session ID to remove
 */
export const removeSessionId = (sessionId) => {
  const sessionIds = getSessionIds();
  const updatedSessionIds = sessionIds.filter(id => id !== sessionId);
  storeSessionIds(updatedSessionIds);
};

/**
 * Checks if a session ID exists in localStorage
 * @param {string} sessionId - The session ID to check
 * @returns {boolean} True if the session ID exists
 */
export const hasSessionId = (sessionId) => {
  const sessionIds = getSessionIds();
  return sessionIds.includes(sessionId);
};

/**
 * Clears all device-related data from localStorage
 */
export const clearDeviceData = () => {
  localStorage.removeItem(DEVICE_ID_KEY);
  localStorage.removeItem(SESSION_IDS_KEY);
  localStorage.removeItem('goalfy_sessionId'); // Legacy key
  localStorage.removeItem('goalfyloginTimestamp');
}; 